module.exports = __webpack_public_path__ + "img/hr-tree-05-i-trunk.ccc4f82d.png";